<template>
  <v-row
    :class="`deck-exodia-footer deck-exodia-footer--${size} text-truncate`"
    no-gutters
  >
    <v-col class="flex-grow-1 text-truncate deck-exodia-footer__content">
      <slot name="footer-content">
        <span :class="`deck-exodia-footer__content-text deck-exodia-footer__content-text--${size}`">
          {{ footerContent }}
        </span>
      </slot>
    </v-col>
    <v-col
      v-if="hasBtns"
      ref="exodiaButtons"
      class="deck-exodia-footer__buttons"
    >
      <v-row
        no-gutters
        class="flex-nowrap text-truncate"
      >
        <v-col v-if="secondaryBtnText || secondaryBtnIcon">
          <deck-button
            is-ready
            color="primary"
            kind="ghost"
            :size="buttonSize"
            :disabled="secondaryBtnDisabled"
            @click="$emit('secondaryBtnClick')"
          >
            <v-icon
              v-if="secondaryBtnIcon"
              data-testid="secondary-button-icon"
              :class="secondaryBtnText ? 'mr-2' : ''"
            >
              {{ secondaryBtnIcon }}
            </v-icon>
            {{ secondaryBtnText }}
          </deck-button>
        </v-col>

        <v-col
          v-if="primaryBtnText || primaryBtnIcon"
          class="ml-2"
        >
          <deck-button
            is-ready
            color="primary"
            :size="buttonSize"
            :disabled="primaryBtnDisabled"
            @click="$emit('primaryBtnClick')"
          >
            <v-icon
              v-if="primaryBtnIcon"
              data-testid="primary-button-icon"
              :class="primaryBtnText ? 'mr-2' : ''"
            >
              {{ primaryBtnIcon }}
            </v-icon>
            {{ primaryBtnText }}
          </deck-button>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'DeckExodiaFooter',
  props: {
    size: { type: String, required: true },
    footerContent: { type: String, default: null },
    primaryBtnText: { type: String, default: null },
    primaryBtnIcon: { type: String, default: null },
    secondaryBtnText: { type: String, default: null },
    secondaryBtnIcon: { type: String, default: null },
    primaryBtnDisabled: { type: Boolean, default: false },
    secondaryBtnDisabled: { type: Boolean, default: false },
  },
  emits: ['secondaryBtnClick', 'primaryBtnClick'],
  computed: {
    hasBtns() {
      return this.primaryBtnText
        || this.primaryBtnIcon
        || this.secondaryBtnText
        || this.secondaryBtnIcon;
    },
    buttonSize() {
      return this.size === 'small' ? 'small' : 'default';
    },
  },
};
</script>

<style lang="scss" scoped>
.deck-exodia-footer {
  border-radius: 0 !important;
  flex-wrap: wrap-reverse;
  justify-content: end;
  min-height: 36px;
  padding: var(--z-s2);

  &--small{
    min-height: 32px;
  }
}

.deck-exodia-footer__content{
  min-width: 176px;
}

.deck-exodia-footer__content-text {
  font-size: 16px !important;
  line-height: 36px;
  color: rgba(0, 0, 0, 0.4) !important;
  margin-top: 4px;

  &--small{
    font-size: 12px !important;
    line-height: 32px;
  }
}

.deck-exodia-footer__buttons{
  flex-grow: 0;
}

</style>
